import { useTheme } from '@emotion/react';
import type { StackProps } from '@hover/blueprint';
import { HStack, IconButton } from '@hover/blueprint';
import { iUser } from '@hover/icons';
import React from 'react';

import { nudge } from 'src/modules/homeownerApp/helpers/styles';
import { useHomeownerAppContext } from 'src/modules/homeownerApp/hooks/useHomeownerAppContext';
import { HomeownerAppMenuNames } from 'src/modules/homeownerApp/providers/HomeownerAppProvider';
import { Button, Logo } from 'src/shared/components';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

interface HomeHeaderProps extends StackProps {}

const HomeHeader = (props: HomeHeaderProps) => {
  const { loggedIn, setCurrentMenu, trackingData } = useHomeownerAppContext();
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);

  const { colors } = useTheme();

  return (
    <HStack
      as="header"
      justifyContent="space-between"
      px={{ base: '500', tablet: '700' }}
      py="500"
      {...props}
    >
      {loggedIn ? (
        <IconButton
          icon={iUser}
          iconSize="medium"
          label={t('navbar.profile')}
          ml="auto"
          onClick={() => setCurrentMenu(HomeownerAppMenuNames.PROFILE)}
          size="small"
          variant="ghost"
          {...nudge(100, 'right')}
        />
      ) : (
        <>
          <Logo
            sx={{
              filter: `drop-shadow(0 0 4px ${colors.darkAlpha[500]})`,
            }}
          />
          <Button
            colorScheme="light"
            onClick={() => setCurrentMenu(HomeownerAppMenuNames.SIGN_IN)}
            optionalTrackingProperties={{
              ...trackingData,
              track_id: 'mobile-landing-page-login-button',
              button_location: 'top-of-page',
            }}
            size="small"
            textShadow={`0 0 4px ${colors.darkAlpha[500]}`}
            variant="ghost"
            {...nudge(300, 'right')}
          >
            {`${t('navbar.logIn')}`}
          </Button>
        </>
      )}
    </HStack>
  );
};

export { HomeHeader };
